var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15,
    cy: 14.5786,
    rx: 14.3618,
    ry: 14.3618,
    fill: "#374DA0",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6633 21.2417H12.4122C11.9497 21.2417 11.5538 21.0771 11.2247 20.748C10.895 20.4183 10.7302 20.0222 10.7302 19.5597V7.78553C10.7302 7.32298 10.895 6.92686 11.2247 6.59719C11.5538 6.26807 11.9497 6.10352 12.4122 6.10352H18.2993L23.3453 11.1496V19.5597C23.3453 20.0222 23.1808 20.4183 22.8517 20.748C22.522 21.0771 22.1259 21.2417 21.6633 21.2417ZM17.4583 11.9906V7.78553H12.4122V19.5597H21.6633V11.9906H17.4583ZM9.04818 24.6057C8.58562 24.6057 8.18979 24.4412 7.86067 24.112C7.531 23.7824 7.36616 23.3862 7.36616 22.9237V11.1496H9.04818V22.9237H18.2993V24.6057H9.04818Z",
    fill: "#374DA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.023d46b86e50df4e9cd955a72ed39c57.svg";
export { ForwardRef as ReactComponent };